(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["price"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant:update', (event) => {
    const variant = event.detail?.resource;
    const productId = event.detail?.data?.productId;
    if (!variant || !productId) return;

    document.querySelectorAll('product-price').forEach((el) => {
      if (el.dataset.productId != productId) return;

      const label = el.querySelector('.discount-label');
      if (!label) return;

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const diff = variant.compare_at_price - variant.price;
        const pct = Math.round((diff / variant.compare_at_price) * 100);
        if (label.dataset.format !== 'amount' && label.dataset.format !== 'sale') label.textContent = `-${pct}%`;
        label.style.display = '';
      } else {
        label.style.display = 'none';
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
